import * as React from 'react';
import { useLocation } from 'react-router-dom';

import clsx from 'clsx';

import { NavBar } from '@app/components/Header/NavBar';
import { items } from '@app/components/Header/Menu';
import { InfoSection } from '@app/components/Header/InfoSection';

import { Message } from '@app/pages/MainPage/Subscribe/Subscribe';
import { NotificationPlacement, Notification } from '@app/components/Notification/Notification';
import { BurgerMenu } from '@app/components/BurgerMenu/BurgerMenu';
import { BurgerContext } from '@app/services/contexts';

import '@app/scss/components/header.scss';

const home = '/';

export const Header: React.FC = () => {
	const location = useLocation();
	const isMain = location.pathname === home;
	const { alert, changeAlert } = React.useContext(BurgerContext);

	React.useEffect(() => {
		setTimeout(() => changeAlert?.(undefined), 5000);
	}, [alert]);

	return (
		<>
			<header className={clsx('site-header', isMain && 'is-main-page')}>
				<InfoSection />
				<NavBar items={items} />
				<BurgerMenu items={items} />
				{
					isMain ? (
						<div className="col-12 col-xs-7 col-lg-9 site-header__title">
							<div className="font-family_primary condensed font-weight_semi-bold text-size_extra-large">
								<b>The world's best destinations with the&nbsp;</b>
								<i className="font-family_decorative font-weight_regular">World's best </i>
								<b>travel agency</b>
							</div>
						</div>
					) : null
				}
			</header>
			{alert && changeAlert && (
				<Notification
					type={alert?.type}
					content={<Message text={alert.message} onClose={changeAlert} />}
					placement={NotificationPlacement.BottomRight}
					className="col-4"
				/>
			)}
		</>
	);
};
